import React, {Component} from "react";
import MaterialIcon from '../MaterialIcon';
import {connect} from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {FormattedMessage} from 'react-intl';
import updateCurrentLanguage from "../../actions/multiLanguageActions";

class TopMenu extends Component {

  constructor(props) {
    super(props);
    this.openSettingsMenu = this.openSettingsMenu.bind(this);
    this.openSubMenuCard = this.openSubMenuCard.bind(this);
    this.logout = this.logout.bind(this);
    this.getUserEmail = this.getUserEmail.bind(this);
    this.updateLocale = this.updateLocale.bind(this);
    this.state = {
      openSettingsHidden: true,
      isSubMenuCardHidden: true,
      redirect2Root: false,
    };
  }



  openSubMenuCard() {
    this.setState({
      isSubMenuCardHidden: !this.state.isSubMenuCardHidden
    });
  }

  openSettingsMenu() {
    this.setState({
      openSettingsHidden: !this.state.openSettingsHidden
    });
  }

  logout(){
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('itemVisibleColumn');
    localStorage.removeItem('eventVisibleColumn');
    localStorage.removeItem('userVisibleColumn');
    localStorage.removeItem('eventFilterSettings');
    localStorage.removeItem('itemFilterSettings');
    localStorage.removeItem('userFilterSettings');
    this.setState({
        user : null,
        redirect2Root: true
      });
      window.location.assign("/"); 
  }

  getUserEmail() {
    return localStorage.getItem(`user`);
  }

  showSettingsIfAdmin() {
    let bearerToken = localStorage.getItem(`token`);
    if(!bearerToken) {
      return
    }
    bearerToken = bearerToken.replace('Bearer ','');

    const bearerTokenInformation = bearerToken.substring(bearerToken.indexOf('.') + 1, bearerToken.lastIndexOf('.'));
    const decoded = atob(bearerTokenInformation);
    const decodedObject = JSON.parse(decoded);
    const decodedRolArray = decodedObject.rol;
    const role = decodedRolArray[0];

    if(role != null && role.toString() === 'ADMIN') {
      return <Link className="clickable" to="/settings"><FormattedMessage id="Settings"/></Link>
    }
  }
  updateLocale(event) {
      this.props.updateCurrentLanguage(event.target.value);
      localStorage.setItem('locale', event.target.value);
  }

  render() {
    let logicVersion = "";
    if(this.props.logicData && typeof this.props.logicData.version !== 'undefined'){
      logicVersion = `-v[${this.props.logicData.version}]`;
    }
    let logicName = '';
    if(this.props.logicData && typeof this.props.logicData.logic !== 'undefined'){
      logicName = this.props.logicData.logic.name;
    }
    const visibleName = logicName + logicVersion;

    let isSettingsHidden = {
      display: this.state.openSettingsHidden ? "none" : "block"
    };

    const splittedCurrentPathArray = this.props.location.pathname.split("/");
    const basePath = (splittedCurrentPathArray.length > 1 ? splittedCurrentPathArray[1] : splittedCurrentPathArray[0] );

    const currentNavigationItemArray = this.props.navigation.mainNavigation.filter( (item)=> {
        return (item.link === ("/"+basePath));
    });

    let menuTitle = "Home";
    if( currentNavigationItemArray && currentNavigationItemArray[0] ) {
      menuTitle = currentNavigationItemArray[0].title;
    }

    return (
      <div className="top-menu">
        <div className="row">
        <div className="col">
          <div className="current-menu-item">
            <span className="current-menu-item-title" ><FormattedMessage id={menuTitle}/></span>
            <MaterialIcon icon="keyboard_arrow_right" />
            <span>{visibleName}</span>
          </div>
          <nav>
              <div className="sub-menu-section" onClick={this.openSubMenuCard}>
                {/* <span className="sub-menu-section-title" >API</span>
                <MaterialIcon icon="keyboard_arrow_down" /> */}
                {/* <div style={isSubMenuCardHidden} className="sub-menu-card open">
                  <nav>
                  <div className="sub-menu-section-item">
                    <MaterialIcon icon="keyboard_arrow_right" />
                    <span className="sub-menu-section-item-title" >Select</span>
                    <MaterialIcon icon="keyboard_arrow_left" />
                  </div>
                  <Link to="/" className="sub-menu-section-item">API</Link>
                  </nav>
                </div> */}
              </div>
              {/* <Link  className= "active menu-link" to="/" title="Test">Test</Link> */}
          </nav>


        </div>
        <div className="col-auto">
          {/* <div className="main-search">
            <div className="search-dropdown" onClick={this.openNaviMenu}>
                  <div className="form-select">
                                    <span className="arrow"><MaterialIcon icon="keyboard_arrow_down" size={24}/></span>
                                    <select>
                                        <option value="All">All</option>
                                        <option value="Menu">Menu</option>
                                        <option value="Logic">Logic</option>
                                        <option value="Page">Page</option>
                                        <option value="Design">Design</option>
                                        <option value="ReportPage">Report Page</option>
                                        <option value="Touchpoint">Touchpoint</option>
                                    </select>
                    </div>
            </div>
            <div className="search-area">
              <input
                placeholder="Search"
                type="text"
                name="search"
                className="main-search-input"
              />
              <MaterialIcon icon="search" />
            </div>
          </div> */}
            <div className="form-select locale-dropdown">
                <span className="arrow"><MaterialIcon icon="keyboard_arrow_down"/></span>
                <select onChange={this.updateLocale} defaultValue={localStorage.getItem('locale')}>
                    <option value="en">EN</option>
                    <option value="tr">TR</option>
                </select>
            </div>
          <div className="common-settings">
            <button
              className={
                this.state.openSettingsHidden
                  ? "common-settings-button"
                  : "common-settings-button active"
              }
              title="settings"
              onClick={this.openSettingsMenu}
            >
              <MaterialIcon icon="settings" />
            </button>
            <div className="common-settings-menu" style={isSettingsHidden}>
              <div className="block">
                <div>{this.getUserEmail()}</div>
              </div>
              <div className="block">
                <div>{this.showSettingsIfAdmin()}</div>
                <Link className="clickable" to="/account-info"><FormattedMessage id="Account Info"/></Link>
                <div className="clickable" onClick={this.logout}><FormattedMessage id="Logout"/></div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
      navigation: state.navigation
  }
}

//eslint-disable-next-line react/display-name
const withRouter = TopMenu => props => {
  const params = useParams();
  const location = useLocation();
  return (
    <TopMenu {...props} {...{params, location}}/>
  );
};

export default withRouter(connect(mapStateToProps, {updateCurrentLanguage})(TopMenu));